"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Caution from foundation/Caution
 * @trackcomponent
 */
export const Caution = createSVGIcon(
  <>
    <path
      d="M1.63182 42.0334L25.3498 2.69198C26.5622 0.676892 29.4375 0.676892 30.6499 2.69198L54.3679 42.0334C55.6268 44.1272 54.1347 46.8192 51.7101 46.8192H4.27406C1.84942 46.8192 0.357326 44.1272 1.63182 42.0334Z"
      stroke="currentColor"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.0078 16.1206V33.3276"
      stroke="currentColor"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.0082 40.8998C28.9868 40.8998 29.78 40.0963 29.78 39.1051C29.78 38.1139 28.9868 37.3104 28.0082 37.3104C27.0296 37.3104 26.2363 38.1139 26.2363 39.1051C26.2363 40.0963 27.0296 40.8998 28.0082 40.8998Z"
      fill="currentColor"
    />
  </>,
  "Caution",
  { viewBox: "0 0 56 48", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
